import React, { useEffect } from "react";
import { observer } from "mobx-react";
import {
  Button,
  HStack,
  Modal,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import { translations } from "@/constants/translations";
import { useStore } from "@/store";
import { OrderNarcanCALogo } from "../Logo";
import { H3 } from "../Heading";
import { renderInnerHtml } from "@/helpers/dom";
import { telemetry } from "@/telemetry";

export const LeavingModal = observer(() => {
  const { activeLanguage, closeLeavingModal, leavingModalUrl, ga4Store } =
    useStore();
  const language = translations.common["leaving-modal"][activeLanguage];
  const destinationHost = telemetry.getHost(leavingModalUrl);

  useEffect(() => {
    if (leavingModalUrl)
      telemetry.trackEvent("leaving_modal_shown", {
        destination_host: telemetry.getHost(leavingModalUrl),
      });
  }, [leavingModalUrl]);

  const handleContinue = () => {
    telemetry.trackEvent("leaving_modal_answered", {
      choice: "continue",
      destination_host: destinationHost,
    });
    ga4Store.clickExternalLink(leavingModalUrl);
    window.open(leavingModalUrl, "_blank");
    closeLeavingModal();
  };

  const handleGoBack = () => {
    telemetry.trackEvent("leaving_modal_answered", {
      choice: "go_back",
      destination_host: destinationHost,
    });
    closeLeavingModal();
  };

  return (
    <Modal
      isOpen={!!leavingModalUrl}
      onClose={handleGoBack}
    >
      <ModalOverlay />
      <ModalContent
        p="20"
        maxWidth="container.md"
      >
        <Stack
          spacing="14"
          alignItems="center"
        >
          <OrderNarcanCALogo />
          <H3 textAlign="center">
            {language.you_are_leaving}
            <Text
              as="span"
              color="primary-light"
            >
              {language.orderNARCAN_ca}
            </Text>
          </H3>
          <Stack
            spacing="8"
            textAlign="center"
            maxWidth="500px"
          >
            <Text>{language.you_have_clicked}</Text>
            <Text>{renderInnerHtml(language.click_to_continue)}</Text>
          </Stack>

          <HStack
            justifyContent="space-between"
            width="100%"
          >
            <Button onClick={handleContinue}>{language.continue}</Button>
            <Button onClick={handleGoBack}>{language.go_back}</Button>
          </HStack>
        </Stack>
      </ModalContent>
    </Modal>
  );
});
